import axios from 'axios'
import Vue from 'vue'
// import Vuex from 'vuex'

export default ({
  state: {
    companys: [],
    company: {}
  },
  getters: {
    get_companys (state) {
      return state.companys
    },
    get_company (state) {
      return state.company
    }
  },
  mutations: {
    GET_COMPANY (state, companys) {
      state.companys = []
      state.companys.push(...companys)
    },
    POST_COMPANY (state, company) {
      state.company = {}
      state.company = company
      state.companys.push(company)
    }
  },
  actions: {
    getCompanys ({ commit }, action) {
      axios.post('/empresas', (action) ? action.data : {}).then(response => {
        commit('GET_COMPANY', response.data)
      })
        .catch(error => {
          if (error == null) {
            Vue.swal({
              type: 'error',
              title: 'Ooops!',
              text: 'Problemas con el servidor, contactar al sistemas !!'
            })
          }
        })
    },
    postCompanys ({ commit }, data) {
      axios.post('/empresas', data).then(response => {
        commit('POST_COMPANY', response.data)
      })
        .catch(error => {
          if (error == null) {
            Vue.swal({
              type: 'error',
              title: 'Ooops!',
              text: 'Problemas con el servidor, contactar al sistemas !!'
            })
          }
        })
    }

  }
})
